import {IPaylodAction} from '../interfaces/dispatchers/IAction'
import {IConstrImport} from '../interfaces/reducers/IConstrImport'
import {CoordinateSystem} from '../core/enums/CoordinateSystem'
import {ConstrImportAction} from '../enums/ActionTypes/ConstrImportAction'

const initState: IConstrImport = {
  inputData: {
    cp1251: true,
    loading: false,
    dataCS: CoordinateSystem.BG_705,
    planName: '',
    planDate: new Date(),
    expanded: false,
    cm5Checked: true,
    LocalityId: 2,
    layerNames: {
      MatritzaBlockName: 'MATRIX',

      ZoneAttName: 'Z',
      FlooringAttName: 'EH',
      DensityAttName: 'DENSITY',
      KintAttName: 'KINT',
      MinGreenAreaAttName: 'GREEN',
      ConstructionTypeAttName: 'TYPE',
      SpecificParamsAttName: 'SPEC',

      ContructionPolygonLayerName: 'ZP_ZASTROQVANE',

      ConstructionLine1LayerName: 'ContructionSegment1',
      ConstructionLine2LayerName: 'ContructionSegment2',
      ConstructionLine3LayerName: 'ContructionSegment3',
      ConstructionLine4LayerName: 'ContructionSegment4',
      ConstructionLine5LayerName: 'ContructionSegment5',

      BuildingsLayerName: 'ZP_ZASTROQVANE_2',
      BuildingsLayerNameDashed: 'ZP_ZASTROQVANE_2_DASHED',
      SGRBlockName: 'SGR_ATT',
      SGRZAttName: 'H',
      SGRFloorsAttName: 'ET'
    },
    startedImportGuid: '',
    errors: []
  },
  connectValidationData: {
    loading: false,
    errors: {messages: [], dxf: ''},
    exists: false
  },
  importActionData: {
    loading: false,
    errors: [],
    success: false
  }
}
export const constrImport = (state: IConstrImport = initState, action: IPaylodAction): IConstrImport => {
  switch (action.type) {
    case ConstrImportAction.UPDATE_IMPORT_DATA:
      return {...state, inputData: {...action.payload}}
    case ConstrImportAction.UPDATE_IMPORT_DATA_LAYERS:
      return {...state, inputData: {...state.inputData, layerNames: {...action.payload}}}
    case ConstrImportAction.UPDATE_CONNECT_VALIDATE_DATA:
      return {...state, connectValidationData: {...action.payload}}
    case ConstrImportAction.UPDATE_IMPORT_ACTION_DATA:
      return {...state, importActionData: {...action.payload}}
    default:
      return state
  }
}
